export default {
  ja: {
    tickets: {
      heading: 'TICKETS',
      ticket_type: '通常チケット',
      description: '※会期中無休（雨天催行、荒天時は中止の可能性あり） \n' +
        '※万が一の中止等は公式サイトや公式Instagramにてお知らせします。\n' +
        '※都合により内容は予告なく変更する場合があります。',
      note: '混雑状況により、人数制限を行う場合がございます。',
      ticketTypes: [
        {
          id: 'regular',
          name: '通常チケット',
          description: '',
          note: '※未就学児および障がい者手帳をお持ちの方は入場無料',
          headers: [
            { text: '料金', colspan: 1 }
          ],
          priceTypes: [
            { name: '通常', strikethrough: false }
          ],
          rows: [
            {
              category: '大人（中学生以上）',
              prices: [
                { amount: '2,000円' }
              ]
            },
            {
              category: '子供（小学生）',
              prices: [
                { amount: '1,000円' }
              ]
            }
          ]
        },
        {
          id: 'lantern',
          name: 'NAKEDディスタンス提灯®\n' + 'セットチケット',
          description: '入場券に大人気のNAKEDディスタンス提灯®のレンタルができるセットチケット',
          note: '※未就学児および障がい者手帳をお持ちの方は入場無料',
          headers: [
            { text: '料金', colspan: 1 }
          ],
          priceTypes: [
            { name: '通常', strikethrough: false }
          ],
          rows: [
            {
              category: '大人（中学生以上）',
              prices: [
                { amount: '2,500円' }
              ]
            },
            {
              category: '子供（小学生）',
              prices: [
                { amount: '1,500円' }
              ]
            }
          ]
        },

      ],
      agency: {
        title: 'ご購入はこちら',
        sold_out: '販売終了しました',
        event_ended: '販売終了しました',
        sp: 'スマホで発券したい方',
        cv: 'コンビニで発券したい方',
        items: [

          {
            type: 'button',
            text: 'アソビュー！',
            link: 'https://www.asoview.com/channel/ticket/VoDeZvmuPm/ticket0000044404/',
            class: '',
            disabled: false
          },
        ]
      },
      notice: {
        title: '注意事項',
        note: '※未就学児および障がい者手帳をお持ちの方は入場無料',
        caption:
          '※会場でも当日券を販売いたします。ただし、会場での当日券販売を制限させていただく可能性がございます。\n' +
          '※障害者手帳をお持ちのご本人は割引／無料の対象となります。\n'+
          '付き添いの方は通常料金となります。受付にて証明書をご提示ください。\n' +
          '※本イベントは20:30最終入場です。入場待機列の状況により、20:30に受付を終了する可能性があります。その場合、入場券をお持ちでも入場することができませんので、あらかじめご了承ください。\n' +
          '※那谷寺の一般拝観のチケットでは入場できません。イベント専用チケットをご購入ください。\n' +
          '※混雑状況により、入場制限を行う場合がございます。\n' +
          '※荒天などやむを得ない理由で変更または中止する場合があります。\n' +
          '※チケットの払い戻しはできません。\n' +
          '※本イベントでは、観覧エリアが限定されており、ご入場いただけないエリアがあります。\n' +
          '※境内での喫煙はご遠慮ください。\n' +
          '※場内での一脚・三脚のご使用はご遠慮願います。\n' +
          '※ペット同伴不可。',
        read_more: 'もっと見る',
        close: '閉じる',
      },
      coming_soon: '※チケット情報は9月上旬公開予定となります',
    },
  },
  en: {
    tickets: {
      heading: 'TICKETS',
      ticket_type: 'TICKETS',
      description: 'Click here to purchase tickets. We also offer discount early-bird tickets and a ticketing service that allows you to issue tickets using your smartphone.\n' + '\n' +
        'We will be regulating admissions depending on the congestion of the venue.',
      note: 'We have reached the planned number of tickets and have ended online ticket sales.\n' +
        'Additionally, from November 22 (Fri) to November 24 (Sun), we anticipate a high volume of visitors. \n' +
        'Please note that same-day ticket sales may also end during this period.',

      ticketTypes: [
        {
          id: 'regular',
          name: 'Regular Tickets',
          description: '',
          note: '*Free admission for preschool children and those with a disability certificate',
          headers: [
            { text: 'Price', colspan: 1 }
          ],
          priceTypes: [
            { name: 'Regular', strikethrough: false }
          ],
          rows: [
            {
              category: 'Adult (Junior high school<br>students and older)',
              prices: [
                { amount: '2,000JPY' }
              ]
            },
            {
              category: 'Child (Elementary school<br>students)',
              prices: [
                { amount: '1,000JPY' }
              ]
            }
          ]
        },
        {
          id: 'lantern',
          name: 'NAKED Distance Lantern®\n' + 'Rental Set Ticket',
          description: 'A combo ticket that includes admission and rental of the popular NAKED Distanced Lantern®',
          note: '*Free admission for preschool children and those with a disability certificate',
          headers: [
            { text: 'Price', colspan: 1 }
          ],
          priceTypes: [
            { name: 'Regular', strikethrough: false }
          ],
          rows: [
            {
              category: 'Adult (Junior high school<br>students and older)',
              prices: [
                { amount: '2,500JPY' }
              ]
            },
            {
              category: 'Child (Elementary school<br>students)',
              prices: [
                { amount: '1,500JPY' }
              ]
            }
          ]
        }
      ],
      agency: {
        title: 'Ticket purchase',
        sold_out: 'Sold Out',
        event_ended: 'Sales Ended',
        items: [
          {
            type: 'button',
            text: 'KKday',
            link: 'https://www.kkday.com/en-us/product/195567',
            class: '',
            disabled: false
          },

        ]
      },
      notice: {
        title: 'Important notes',
        note: '*Free admission for residents of the Noto area (Nanao City, Wajima City, Suzu City, Hakui City, Kahoku City, Tsubata Town, Uchinada Town, Shiga Town, Hodatsushimizu Town, Nakanoto Town, Anamizu Town, Noto Town)\n' +
          '*Free admission for preschool children and those with a disability certificate',
        caption:
          '*Same-day tickets will also be sold at the venue. However, day-of-performance ticket sales at the venue may be limited.\n' +
          '*Those with a disability certificate are eligible for a discount or free admission. \n' +
          'Accompanying persons are subject to the regular admission fee. \n' +
          'Please show the above certificate at the reception desk.\n' +
          '*The last entry to the event is at 20:30. Depending on the situation of the waiting line for admission, the reception desk may close at 20:30. In that case, please understand that even if you have an admission ticket, you will not be allowed to enter.\n' +
          '*Tickets for general admission to Natadera Temple will not be accepted. Please purchase a special ticket for the event.\n' +
          '*Admission may be restricted depending on how crowded the event is.\n' +
          '*The event may be changed or cancelled due to stormy weather or other unavoidable reasons.\n' +
          'Tickets are non-refundable.\n' +
          '*This event has a limited viewing area, and some areas may not be accessible.\n' +
          '*Smoking is not permitted in the grounds.\n' +
          '*Please refrain from using monopods and tripods in the grounds.\n' +
          '*No pets are allowed.',
        read_more: 'Show more',
        close: 'Close',
      },
      coming_soon: '*Ticket information is scheduled to be released in early September.',
    },
  },

};

